import trackSkillChanges from '../helpers/trackSkillChanges'
import calcSkillValues from '../helpers/calcSkillValues'

import store from '../store/index'
//-------------------------------
// process specific skill change
//-------------------------------
export default function processSpecificSkillChange({
  skill,
  original_skills,
  changed_skills,
  character,
}) {
  console.log('------------------------')
  console.log('IN processSpecificSkillChange')
  console.log('skill = ' + skill.name)
  console.log(
    '1. skill adjs IN processSpecificSkillChange = ',
    window.$deepCopy(character.skill_adjs),
  )
  //--------------------------
  // get max skill from store
  //--------------------------
  //--------------------------
  const max_skill = store.state.combat.config.max_skill
  //----------------------------
  // calc specific skill values
  //----------------------------
  calcSkillValues({ skill, character, max_skill })
  //----------------------------------------------
  // track skill changes (performed in SkillCard)
  //----------------------------------------------
  changed_skills = trackSkillChanges({
    skill,
    original_skills,
    changed_skills,
    character_id: character.id,
  })
  // console.log('original_skills = ', original_skills)
  console.log('QQQQQQQ changed_skills = ', changed_skills)
  console.log(
    '2. skill adjs EXITING processSpecificSkillChange = ',
    window.$deepCopy(character.skill_adjs),
  )
  //-----------------------
  // return changed skills
  //-----------------------
  return changed_skills
}
